import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { RequestState } from '../shared/models/request-state';
import { ActivityRecordResponse } from './models/response/activity-record.response';
import { ApiCacheService } from '@shared/services/api-cache.service';

@Injectable({
  providedIn: 'root',
})
export class CalendarService {
  private readonly _activityRecordApiUrl = `${environment.apiUrl}ActivityRecord`;

  constructor(private cacheService: ApiCacheService) {}

  /** Standard method of fetching activity record. Uses cached data and checks expiration. */
  getActivityRecord(
    dateString: string,
    employeeNumber?: string
  ): Observable<RequestState<ActivityRecordResponse>> {
    const cacheId = this.getCacheId(dateString, employeeNumber);
    let empNumberString = '';

    if (employeeNumber) {
      empNumberString = `/${employeeNumber}`;
    }

    const url = `${this._activityRecordApiUrl}/${dateString}${empNumberString}?includeSequences=true&includeCRR=false`;

    return this.cacheService.request<ActivityRecordResponse>(cacheId, url);
  }

  /** Used to manually refresh activity record. */
  refreshActivityRecord(
    dateString: string,
    employeeNumber?: string
  ): Observable<RequestState<ActivityRecordResponse>> {
    const cacheId = this.getCacheId(dateString, employeeNumber);
    let empNumberString = '';

    if (employeeNumber) {
      empNumberString = `/${employeeNumber}`;
    }

    const url = `${this._activityRecordApiUrl}/${dateString}${empNumberString}?includeSequences=true&includeCRR=false`;

    return this.cacheService.forceRefreshGet<ActivityRecordResponse>(
      cacheId,
      url
    );
  }

  private getCacheId(dateString: string, employeeNumber?: string): string {
    let empNumberString = '';

    if (employeeNumber) {
      empNumberString = `/${employeeNumber}`;
    }

    return `activityRecord-${dateString}${empNumberString}`;
  }
}
